// extracted by mini-css-extract-plugin
module.exports = {"signup-captcha":"captcha-module__signup-captcha___2lV-7","captcha-error":"captcha-module__captcha-error___ayddO","wrapper":"captcha-module__wrapper___f_AIq"};